import { render, staticRenderFns } from "./AddressBookByDID.vue?vue&type=template&id=25a789ae&scoped=true&"
import script from "./AddressBookByDID.vue?vue&type=script&lang=js&"
export * from "./AddressBookByDID.vue?vue&type=script&lang=js&"
import style0 from "./AddressBookByDID.vue?vue&type=style&index=0&id=25a789ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a789ae",
  null
  
)

export default component.exports